import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axiosClient from 'api/axiosClient'
import { Container, Row, Col } from 'reactstrap';
import Loader from "react-loader-spinner";
import ReactHtmlParser from 'react-html-parser'
import SlideResearch from './SlideResearch/SlideResearch';
import SlideConferences from './SlideConferences/SlideConferences';
//optimize image
// import Img from 'react-optimized-image';
import StartImg from 'assets/img/researchImages/star.png';
import ResearchLogo from 'assets/img/researchImages/research-logo.png';
import ISIImg from 'assets/img/researchImages/ISI-background.jpeg';
import IPCImg from 'assets/img/researchImages/IPC-background.jpeg';
import { Bar } from 'react-chartjs-2';
import { useIntl } from 'react-intl'; // ✅ Thêm useIntl



export default function Research() {
    const intl = useIntl();

    const [infoNewsPublication, setinfoNewsPublication] = useState([])
    const [infoNewsPatent, setinfoNewsPatent] = useState([])
    const [loaded, setLoaded] = useState()
    const isVietnamese = intl.locale === 'vn';

    const [chartData, setChartData] = useState(null); // Dữ liệu API sẽ lưu ở đây
    const options = {
        legend: { display: true },
        title: { display: false },
        responsive: true,
        scales: {
            xAxes: [{ stacked: true }],
            yAxes: [{ stacked: true }]
        }
    };


    useEffect(() => {

        // set loading to wait get data
        setLoaded(false)
        const requestUrlPublication = `/publications?page=1&size=2&type=publication&isFeatured=1&unit=Home`
        const requestUrlPatent = `/publications?page=1&size=2&type=patent&isFeatured=1&unit=Home`

        axiosClient.get(requestUrlPublication).then(response => {
            const temp = response.data
            setinfoNewsPublication(temp)
        }).catch(error => {
            console.error("Lỗi gọi API!", error)
        })
        axiosClient.get(requestUrlPatent).then(response => {
            const temp = response.data
            setinfoNewsPatent(temp)
            setLoaded(true)
        }).catch(error => {
            console.error("Lỗi gọi API!", error)
        })

    }, [])
    return (
        <>
        <Container className="wp-research">
            <h2 className="research-title">{intl.formatMessage({ id: 'Research' })}</h2>
            {
                !loaded ? <Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" /> :
                    <div>
                        <Row className="Research" style={{ marginRight: '0px', marginLeft: '0px' }}>
                            <div className="research-lable">
                                <img src={StartImg} alt="img" />
                                <h3> {intl.formatMessage({ id: 'ISI, Scopus & Intellectual Property Collection' })}</h3>
                                <img className="research-logo" src={ResearchLogo} alt="img" />
                            </div>
                            <div className="reseach-body">
                                <div className="research-item">
                                    <img src={ISIImg} alt="img"></img>
                                    <div className="ISI-item research-content">
                                        <h4> {intl.formatMessage({ id: 'ISI, Scopus Collection' })}</h4>
                                        <div className="ISI-body">
                                            <ul>
                                                {infoNewsPublication.map((item, index) => (
                                                    <li key={`pub-${item.id || index}`}>
                                                        <div className="infoCollection">
                                                            <span>{ReactHtmlParser(item.authors)}</span>, "<span>{ReactHtmlParser(item.title)}</span>", {item.resource.includes("<p>") ? <span>{ReactHtmlParser(item.resource)}</span> : <span>{item.resource}</span>}, <span>{item.publish_month === 0 ? "" : `${item.publish_month}.`}{item.publish_year}</span>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <a href={isVietnamese ? 'http://eprints.lqdtu.edu.vn/' : '/research/list'} className="viewAllCollection" target="_blank" rel="noopener noreferrer">
                                            {intl.formatMessage({ id: 'View All' })}
                                        </a>
                                    </div>
                                </div>
                                <div className="research-item">
                                    <img src={IPCImg} alt="img"></img>
                                    <div className="IPC-item research-content">
                                        <h4>{intl.formatMessage({ id: 'Intellectual Property Collection' })}</h4>
                                        <div className="ISI-body">
                                            <ul>
                                                {infoNewsPatent.map((item, index) => (
                                                    <li key={`pat-${item.id || index}`}>
                                                        <div className="infoCollection">
                                                            <span>{ReactHtmlParser(item.authors)}</span>, "<span>{ReactHtmlParser(item.title)}</span>", {item.resource.includes("<p>") ? <span>{ReactHtmlParser(item.resource)}</span> : <span>{item.resource}</span>}, <span>{item.publish_month === 0 ? "" : `${item.publish_month}.`}{item.publish_year}</span>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <Link to={`/patent/list`} className="viewAllCollection"> {intl.formatMessage({ id: 'View All' })} </Link>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </div>
            }
        </Container>
        <div className="wp-conferences-bg" style={{ 
            backgroundImage: `url(${require('assets/img/anh_nen_conf.jpg').default})`, 
            backgroundSize: 'cover', 
            backgroundPosition: 'center',
            display: 'flex',
            alignItems: 'center',
            minHeight: '400px',
            padding: '40px 0',
            marginTop: '30px',
            marginBottom: '30px'
        }}>
            <Container>
                <SlideConferences />
            </Container>
        </div>
        <Container className="wp-research" style={{ paddingTop: '0' }}>
            <SlideResearch />
        </Container>
    </>
    )
}
